"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _styles = require("@mui/material/styles");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = exports.useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {},
    // a style rule
    label: {},
    // a nested style rule
    text: function text(props) {
      if (['neutral', 'success', 'warning', 'error'].includes(props.color)) {
        return {
          color: props.disabled ? theme.palette.action.disabled : theme.palette[props.color].main,
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(theme.palette[props.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              backgroundColor: 'transparent'
            }
          }
        };
      } else if (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(props.color)) {
        return {
          color: props.disabled ? theme.palette.action.disabled : props.color,
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(props.color, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
              backgroundColor: 'transparent'
            }
          }
        };
      }
      return null;
    },
    contained: function contained(props) {
      if (props.variant === 'contained' && ['neutral', 'success', 'warning', 'error'].includes(props.color)) {
        return {
          color: props.disabled ? theme.palette.neutral.contrastText : theme.palette[props.color].contrastText,
          backgroundColor: props.disabled ? theme.palette.neutral.main : theme.palette[props.color].main,
          '&:hover': {
            backgroundColor: theme.palette[props.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              backgroundColor: theme.palette[props.color].main
            }
          }
        };
      } else if (props.variant === 'contained' && /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(props.color)) {
        return {
          color: props.disabled ? theme.palette.neutral.contrastText : theme.palette.getContrastText(props.color),
          backgroundColor: props.disabled ? theme.palette.neutral.main : props.color,
          '&:hover': {
            backgroundColor: (0, _styles.darken)(props.color, theme.palette.tonalOffset * 1.5),
            '@media (hover: none)': {
              backgroundColor: props.color
            }
          }
        };
      } else if (props.variant === 'containedLight' && /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(props.color)) {
        return {
          color: props.disabled ? theme.palette.neutral.contrastText : props.color,
          backgroundColor: (0, _styles.alpha)(props.disabled ? theme.palette.neutral.main : props.color, theme.palette.action.hoverOpacity),
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(props.color, theme.palette.action.hoverOpacity + 0.1),
            '@media (hover: none)': {
              backgroundColor: (0, _styles.alpha)(props.disabled ? theme.palette.neutral.main : props.color, theme.palette.action.hoverOpacity)
            }
          }
        };
      } else if (props.variant === 'containedLight' // && is a palette color
      ) {
        return {
          color: props.disabled ? theme.palette.neutral.contrastText : theme.palette[props.color].main,
          backgroundColor: (0, _styles.alpha)(props.disabled ? theme.palette.neutral.main : theme.palette[props.color].main, theme.palette.action.hoverOpacity),
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(theme.palette[props.color].main, theme.palette.action.hoverOpacity + 0.1),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              backgroundColor: (0, _styles.alpha)(props.disabled ? theme.palette.neutral.main : theme.palette[props.color].main, theme.palette.action.hoverOpacity)
            }
          }
        };
      }
      return null;
    },
    outlined: function outlined(props) {
      if (['neutral', 'success', 'warning', 'error'].includes(props.color)) {
        return {
          color: theme.palette[props.color].main,
          border: "1px solid ".concat((0, _styles.alpha)(theme.palette[props.color].main, 0.5)),
          '&:hover': {
            border: "1px solid ".concat(theme.palette[props.color].main),
            backgroundColor: (0, _styles.alpha)(theme.palette[props.color].main, theme.palette.action.hoverOpacity)
          }
        };
      } else if (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(props.color)) {
        return {
          color: props.color,
          border: "1px solid ".concat((0, _styles.alpha)(props.color, 0.5)),
          '&:hover': {
            border: "1px solid ".concat(props.color),
            backgroundColor: (0, _styles.alpha)(props.color, theme.palette.action.hoverOpacity)
          }
        };
      }
      return null;
    }
  };
});

/**
 * HiButton
 * Inherited from Button
 */
var HiButton = _react.default.forwardRef(function (props, ref) {
  var disableElevation = props.disableElevation,
    variant = props.variant,
    color = props.color,
    otherProps = (0, _objectWithoutProperties2.default)(props, ["disableElevation", "variant", "color"]);
  var classes = useStyles(props);
  var style = (0, _react.useMemo)(function () {
    var style = {};
    if (disableElevation) {
      style.boxShadow = 'none';
    }
    return style;
  }, [disableElevation]);
  var _color = (0, _react.useMemo)(function () {
    if (['neutral', 'success', 'warning', 'error'].includes(color) || /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color) // isHexColor
    ) {
      return 'inherit';
    }
    return color;
  }, [color]);
  var _variant = (0, _react.useMemo)(function () {
    if (variant === 'containedLight') {
      return 'contained';
    }
    return variant;
  }, [variant]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    ref: ref,
    style: style,
    classes: classes,
    color: _color,
    variant: _variant
  }, otherProps));
});
HiButton.defaultProps = {
  disableElevation: false,
  variant: 'text',
  color: 'neutral'
};
var _default = exports.default = HiButton;